import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'shared-wizzards',
    templateUrl: './wizzards.shared.component.html',
    styleUrls: ['./wizzards.shared.component.scss']
})
export class WizzardsComponent implements OnInit {
    @Input() public type: OLO.Components.WIZZARD_TYPE;
    @Input() public locationNo: number; /* Consumer -> shared-wizzard-typeXXX */
    @Input() public menuFlowId: number; /* Consumer -> shared-wizzard-typeXXX */
    @Input() public showDisclaimer: boolean = true;
    constructor() { }

    ngOnInit(): void { }
}
